import { useEffect } from 'react'
import { useEventListener, useOptions } from 'core/hooks'
import { MODES } from 'core/constants'

export const useResizeMode = () => {
  const [options, setOptions] = useOptions()

  const { initialMode, mode, features } = options

  const resizeMode = () => {
    if (!features.verticalToWidgetMobile) {
      return
    }

    if ((!initialMode && mode === MODES.VERTICAL) || initialMode === MODES.VERTICAL) {
      if (!initialMode) {
        setOptions({ ...options, initialMode: mode })
      }
      if (window.innerWidth <= 480 && mode !== MODES.WIDGET) {
        setOptions({ ...options, mode: MODES.WIDGET })
      } else if (window.innerWidth > 480 && mode !== MODES.VERTICAL) {
        setOptions({ ...options, mode: MODES.VERTICAL })
      }
    }
  }

  useEffect(() => {
    resizeMode()
  }, [])

  useEventListener('resize', () => {
    if (features.verticalToWidgetMobile) {
      resizeMode()
    }
  }, [], window)


}
